import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAdminApi, errMsg } from "@/lib/api";

export const STATUSES = ["New", "Called", "Quoted", "Won", "Lost"];

const COLORS = {
  New: "bg-amber-100 text-amber-900", Called: "bg-sky-100 text-sky-900", Quoted: "bg-violet-100 text-violet-900",
  Won: "bg-emerald-100 text-emerald-900", Lost: "bg-stone-200 text-stone-700",
};

export const StatusSelect = ({ inquiry, onDone }) => {
  const call = useAdminApi();
  const change = async (status) => {
    try {
      await call({ method: "patch", url: `/admin/inquiries/${inquiry.id}`, data: { status } });
      toast.success(`Marked as ${status}`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Select value={inquiry.status} onValueChange={change}>
      <SelectTrigger className={`h-8 w-32 border-0 text-xs font-semibold ${COLORS[inquiry.status]}`} data-testid={`inquiry-status-select-${inquiry.id}`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {STATUSES.map((s) => <SelectItem key={s} value={s} data-testid={`status-option-${s.toLowerCase()}`}>{s}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
